"use client";

import React from "react";
import { Link as ZapierLink, Text } from "@zapier/design-system";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import dedent from "dedent";
import rehypeRaw from "rehype-raw";
import styles from "./Markdown.module.css";
import classNames from "classnames";

interface MarkdownProps {
  content: string;
}

interface MarkdownComponentProps {
  children: React.ReactNode;
}

const H1 = ({ children }: MarkdownComponentProps) => (
  <h1 className={styles.headerOne}>
    <Text type="PageHeader">{children}</Text>
  </h1>
);

const H2 = ({ children }: MarkdownComponentProps) => (
  <h2 className={styles.headerTwo}>
    <Text type="SectionHeader">{children}</Text>
  </h2>
);

const H3 = ({ children }: MarkdownComponentProps) => (
  <h3 className={styles.headerThree}>
    <Text type="ParagraphHeader1">{children}</Text>
  </h3>
);

const P = ({ children }: MarkdownComponentProps) => (
  <p className={styles.paragraph}>
    <Text type="Body1">{children}</Text>
  </p>
);

const Link = ({ children, ...rest }: MarkdownComponentProps) => (
  <ZapierLink color="primary" {...rest}>
    {children}
  </ZapierLink>
);

const UL = ({ children }: MarkdownComponentProps) => (
  <Text type="Body1">
    <ul className={classNames([styles.list, styles.unorderedList])}>
      {children}
    </ul>
  </Text>
);

const OL = ({ children }: MarkdownComponentProps) => (
  <Text type="Body1">
    <ul className={classNames([styles.list, styles.orderedList])}>
      {children}
    </ul>
  </Text>
);

export const Markdown = ({ content }: MarkdownProps) => (
  <ReactMarkdown
    className={styles.markdownWrapper}
    // @ts-ignore the types don't seem to match up
    rehypePlugins={[rehypeRaw]}
    skipHtml={false}
    components={{
      h1: H1,
      h2: H2,
      h3: H3,
      p: P,
      a: Link,
      ul: UL,
      ol: OL,
    }}
  >
    {dedent(content)}
  </ReactMarkdown>
);
